import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { graphql, compose } from 'react-apollo';
import { Layout, Dropdown, Menu, Icon, Popover } from 'antd';
import PropTypes from 'prop-types';
import { getCurrentUser } from '../authorization/queries/getCurrentUser';
import { invalidateToken } from '../authorization/mutations/invalidateToken';
import { HEADER_CONTENT_KEY, NAVIGATION_CONTENT_KEY } from './constants';
import Logo from './logo';
import './dashboard.css';

const UserMenuContent = ({ user }) => {
  return (
    <div className="dashboard-header-menu__user">
      <div className="dashboard-header-menu__user-name">{user.name}</div>
      <img alt="" src={user.photo && user.photo.small} />
    </div>
  );
};

class Header extends Component {
  static propTypes = {
    mutate: PropTypes.func.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      error: PropTypes.object,
      current_user: PropTypes.object
    }).isRequired
  };

  get invalidateTokenParams() {
    return {
      variables: {
        input: {
          token: localStorage.getItem('authenticationToken')
        }
      }
    }
  }

  async logOut() {
    try {
      await this.props.mutate(this.invalidateTokenParams);
      localStorage.removeItem('authenticationToken');
      window.location.reload();
    } catch(response) {
      console.log(response);
    }
  }

  get headerContent() {
    return this.getComponent(HEADER_CONTENT_KEY);
  }

  get navigation() {
    return this.getComponent(NAVIGATION_CONTENT_KEY);
  }

  get editProfilePath() {
    return this.navigation[0].props.configs.find(config => config.itemKey === 'profile').path;
  }

  get userProfileActions() {
    return(
      <Menu>
        <Menu.Item key='edit'><Link to={this.editProfilePath}>My profile</Link></Menu.Item>
        <Menu.Item key='logOut'><div onClick={this.onLogoutClick}>Log Out</div></Menu.Item>
      </Menu>
    );
  }

  onLogoutClick = () => {
    this.logOut();
  };

  getComponent(key) {
    return this.props.children.filter((component) => component.key === key);
  }

  render() {
    return (
      <Layout.Header className="dashboard-layout__header">
        <div className="dashboard-header__left-element">
          <Popover placement="bottomLeft" trigger="click" content={this.navigation}>
            <div className="dashboard-layout__compact-menu-button">
              <Icon type="bars" />
            </div>
          </Popover>
          <Logo />
        </div>
        {this.headerContent}
        <Dropdown overlay={this.userProfileActions} trigger={['click']}>
          <span className="dashboard-header-menu">
            <UserMenuContent user={this.props.data.current_user}/>
          </span>
        </Dropdown>
      </Layout.Header>
    );
  }
}

export default compose(
  graphql(getCurrentUser),
  graphql(invalidateToken)
)(Header);



// WEBPACK FOOTER //
// ./src/components/dashboard/header.js